var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "navbar" } }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "wrap-profile" }, [
      _c("img", {
        staticClass: "cursor-pointer m__r--16",
        attrs: {
          src: require("@/assets/icon/help-" +
            (_vm.showContentHelp ? "blue" : "gray") +
            ".svg"),
          width: "20",
          alt: "type-help"
        },
        on: {
          click: function($event) {
            _vm.showContentHelp = !_vm.showContentHelp
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.hideDropdown,
              expression: "hideDropdown"
            }
          ],
          staticClass: "profile",
          on: {
            click: function($event) {
              _vm.showDropdown = !_vm.showDropdown
            }
          }
        },
        [
          _vm.profile_data && _vm.profile_data.photo_url
            ? _c("img", {
                attrs: {
                  src: _vm.profile_data.photo_url,
                  alt: "profile-pic-small"
                }
              })
            : _c(
                "div",
                {
                  staticClass: "initial",
                  style: "background-color: " + _vm.bg_initial_profile
                },
                [_vm._v("\n        " + _vm._s(_vm.initialName) + "\n      ")]
              ),
          _vm._v(" "),
          _c("i", { staticClass: "fa fa-sort-desc" })
        ]
      )
    ]),
    _vm._v(" "),
    _vm.showDropdown
      ? _c("div", { staticClass: "dropdown-profile" }, [
          _vm.profile_data && _vm.profile_data.photo_url
            ? _c("img", {
                attrs: {
                  src: _vm.profile_data.photo_url,
                  alt: "profile-pic-small"
                }
              })
            : _c(
                "div",
                {
                  staticClass: "initial",
                  style: "background-color: " + _vm.bg_initial_profile
                },
                [_vm._v("\n      " + _vm._s(_vm.initialName) + "\n    ")]
              ),
          _vm._v(" "),
          _c("p", { staticClass: "profile-name" }, [
            _vm._v("\n      " + _vm._s(_vm.fullName) + "\n    ")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "profile-email" }, [
            _vm._v("\n      " + _vm._s(_vm.profile_data.email) + "\n    ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section-button" }, [
            _c(
              "button",
              { staticClass: "button", on: { click: _vm.handleLogout } },
              [_vm._v("\n        Logout\n      ")]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showContentHelp
      ? _c(
          "div",
          {
            directives: [
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.hideContentHelp,
                expression: "hideContentHelp"
              }
            ],
            staticClass: "content-help"
          },
          [
            _c("div", { staticClass: "content-help-header" }, [
              _c("h4", [_vm._v(" Help & Documentation ")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "close-properties",
                  on: { click: _vm.hideContentHelp }
                },
                [_vm._v("\n        ×\n      ")]
              ),
              _vm._v(" "),
              !_vm.isOpenDetailModule
                ? _c("img", {
                    staticClass: "img-search",
                    attrs: { src: require("@/assets/icon/search-page.svg") }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isOpenDetailModule
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.search,
                        expression: "search"
                      }
                    ],
                    staticClass: "input-search",
                    attrs: { type: "text", placeholder: "Search" },
                    domProps: { value: _vm.search },
                    on: {
                      keypress: function($event) {
                        if (!("button" in $event) && $event.keyCode !== 13) {
                          return null
                        }
                        $event.preventDefault()
                        _vm.filterDocument($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.search = $event.target.value
                      }
                    }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            !_vm.isOpenDetailModule && !_vm.isOpenSearchModule
              ? _c("div", { staticClass: "content-help-body" }, [
                  _c("div", { staticClass: "module-content" }, [
                    _c("label", [_vm._v("Categorize by Module")]),
                    _vm._v(" "),
                    !_vm.loading_module
                      ? _c(
                          "div",
                          { staticClass: "wrap-module" },
                          _vm._l(_vm.list_module, function(item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "list-module",
                                on: {
                                  click: function($event) {
                                    _vm.openDetailModule(item)
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  staticClass: "m__t--7",
                                  attrs: {
                                    src: item.logo,
                                    width: "35",
                                    height: "35"
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(_vm._s(item.name))
                                ])
                              ]
                            )
                          })
                        )
                      : _c(
                          "div",
                          { staticClass: "wrap-module" },
                          _vm._l(6, function(i) {
                            return _c("div", {
                              key: i,
                              staticClass: "skeleton"
                            })
                          })
                        )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "featured-topic" },
                    [
                      _c("label", [_vm._v("Featured Topic")]),
                      _vm._v(" "),
                      !_vm.loading_featured
                        ? _c(
                            "div",
                            _vm._l(_vm.list_featured, function(item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "list-featured" },
                                [
                                  _c("div", { staticClass: "d-flex" }, [
                                    _c("img", {
                                      staticClass: "m__r--10",
                                      attrs: {
                                        src: item.logo,
                                        width: "20",
                                        height: "20"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "title" }, [
                                      _vm._v(_vm._s(item.name))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  item.documents
                                    ? _c(
                                        "div",
                                        _vm._l(item.documents, function(
                                          itemDoc,
                                          indexDoc
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: indexDoc,
                                              staticClass: "list-document",
                                              on: {
                                                click: function($event) {
                                                  _vm.directToDocsFeatured(
                                                    item,
                                                    itemDoc
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "m__r--10",
                                                attrs: {
                                                  src: require("@/assets/icon/list-document.svg"),
                                                  width: "17"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "title-featured"
                                                },
                                                [_vm._v(_vm._s(itemDoc.title))]
                                              )
                                            ]
                                          )
                                        })
                                      )
                                    : _vm._e()
                                ]
                              )
                            })
                          )
                        : _vm._l(2, function(i) {
                            return _c("div", {
                              key: i,
                              staticClass: "skeleton"
                            })
                          })
                    ],
                    2
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isOpenDetailModule && !_vm.isOpenSearchModule
              ? _c("div", { staticClass: "content-help-body" }, [
                  _c("div", { staticClass: "detail-module" }, [
                    _c("img", {
                      staticClass: "back-to-list",
                      attrs: { src: require("@/assets/icon/arrow-left.svg") },
                      on: { click: _vm.backToModule }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "m__r--10",
                      attrs: {
                        src: _vm.moduleSelected.logo,
                        width: "17",
                        height: "17"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.moduleSelected.name))
                    ])
                  ]),
                  _vm._v(" "),
                  !_vm.loading_document
                    ? _c(
                        "div",
                        _vm._l(_vm.list_document, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "list-document",
                              on: {
                                click: function($event) {
                                  _vm.directToDocs(item)
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "m__r--10",
                                attrs: {
                                  src: require("@/assets/icon/list-document.svg"),
                                  width: "17"
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "title" }, [
                                _vm._v(_vm._s(item.title))
                              ])
                            ]
                          )
                        })
                      )
                    : _c(
                        "div",
                        { staticClass: "m__t--15" },
                        _vm._l(4, function(i) {
                          return _c("div", { key: i, staticClass: "skeleton" })
                        })
                      )
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.isOpenDetailModule && _vm.isOpenSearchModule
              ? _c("div", { staticClass: "content-help-body" }, [
                  !_vm.loading_document_by_search
                    ? _c(
                        "div",
                        [
                          _c("div", { staticClass: "count-result" }, [
                            _vm._v(
                              _vm._s(_vm.count_list_document_by_search) +
                                " results"
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.list_document_by_search, function(
                            item,
                            index
                          ) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "list-document border-bottom",
                                on: {
                                  click: function($event) {
                                    _vm.directToDocsBySearch(item)
                                  }
                                }
                              },
                              [
                                _c("div", [
                                  _c("img", {
                                    staticClass: "m__r--10",
                                    attrs: {
                                      src: require("@/assets/icon/list-document.svg"),
                                      width: "17"
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c(
                                    "div",
                                    { staticClass: "title-by-search" },
                                    [_vm._v(_vm._s(item.title))]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "title",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.decodeHtmlEntities(item)
                                      )
                                    }
                                  })
                                ])
                              ]
                            )
                          })
                        ],
                        2
                      )
                    : _c(
                        "div",
                        { staticClass: "m__t--15" },
                        _vm._l(4, function(i) {
                          return _c("div", { key: i, staticClass: "skeleton" })
                        })
                      )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "content-help-footer" }, [
              _c("img", {
                staticClass: "m__r--10",
                attrs: { src: require("@/assets/icon/forum.svg"), width: "33" }
              }),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("img", {
                staticClass: "open-tab",
                attrs: {
                  src: require("@/assets/automation/open-tab.svg"),
                  width: "12"
                },
                on: { click: _vm.openForum }
              })
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-left" }, [
      _c("img", {
        attrs: { src: require("@/assets/logo/logo-studio.svg"), height: "30" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "title" }, [_vm._v("Officeless Forum")]),
      _vm._v(" "),
      _c("div", { staticClass: "desc" }, [
        _vm._v("\n          Enjoy your new forum! Hop over to "),
        _c("b", [_vm._v("forum.jojonomic.com")]),
        _vm._v(
          ",\n          if you have any questions, or to join our community.\n        "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ad619a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ad619a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/jNavbar.vue
// module id = null
// module chunks = 